import React from 'react';

import { ThemeProvider } from '@material-ui/styles';
import theme from './components/theme';

import Header from './components/Header';
import Hero from './components/Hero';
import Stats1 from './components/Stats1';
import Enough from './components/Enough';
import MainAudio from './components/MainAudio';
import WhatIs from './components/WhatIs';
import FourTypes from './components/FourTypes';
import CervicalCancer from './components/CervicalCancer';
import WhyDoes from './components/WhyDoes';
import PullQuote1 from './components/PullQuote1';
import TheFactors from './components/TheFactors';
import Stats2 from './components/Stats2';
import FindingASolution from './components/FindingASolution';
import PullQuote2 from './components/PullQuote2';
import HowHologic from './components/HowHologic';
import Footnotes from './components/Footnotes';
import Footer from './components/common-footer/src/Footer/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <Hero />
      <Stats1 />
      <Enough />
      <MainAudio />
      <WhatIs />
      <FourTypes />
      <CervicalCancer />
      <WhyDoes />
      <PullQuote1 />
      <TheFactors />
      <Stats2 />
      <FindingASolution />
      <PullQuote2 />
      <HowHologic />
      <Footnotes />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
